import React from "react";
import styles from "./FormFooter.module.scss";
import { Link } from "react-router-dom";

export interface FormFooterProps {
  message: string;
  linkText: string;
  redirectTo: string;
}

export const FormFooter = (props: FormFooterProps) => {
  return (
    <div className={styles.container}>
      <p className={styles.message}>
        <b>{props.message}</b>
      </p>
      <Link className={styles.navigation_link} to={props.redirectTo}>
        {props.linkText}
      </Link>
    </div>
  );
};
